export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  NEWS: {
    ROOT: '/news',
    POST: '/news/:id',
  },
  INSTRUCTION: '/instruction',
  SEARCH: '/search',
  CABINET: '/cabinet',
  APPLICATIONS: {
    ROOT: '/cabinet/applications',
    CREATE: '/cabinet/applications/create',
    CONFIRMED: '/cabinet/applications/confirmed',
    DECLINED: '/cabinet/applications/declined',
    PASSED: '/cabinet/applications/passed',
    FAILED: '/cabinet/applications/failed',
  },
  NOTIFICATIONS: '/cabinet/notifications',
  CHECKING: '/cabinet/checking',
  APPEALS: {
    ROOT: '/cabinet/appeals',
    CREATE: '/cabinet/appeals/create',
  },
  REQUESTS: '/cabinet/requests',
  TEST: {
    ROOT: '/cabinet/test',
    RESULT: '/cabinet/test/result/:id',
  },
  TESTS: '/cabinet/tests',
  EXAM: '/cabinet/exam',
  CERTIFICATES: '/cabinet/certificates',
  INSTRUCTIONS: '/cabinet/instructions',
  USERS: '/cabinet/users',
  ORGANIZATIONS: '/cabinet/organizations',
  LOCATIONS: '/cabinet/locations',
  SCHEDULES: '/cabinet/schedules',
  REFERENCES: {
    ROOT: '/cabinet/references',
    DIRECTIONS: '/cabinet/references/directions',
    REGIONS: '/cabinet/references/regions',
    // DISTRICTS: '/cabinet/references/districts',
    COMMISSIONS: '/cabinet/references/commissions',
    SPECIALTIES: '/cabinet/references/specialties',
  },
  REPORTS: '/cabinet/reports',

  ATTESTATION: '/cabinet/attestation',
};
